import { CreateMixin } from "@pdfking/reactivity/preact"
import { first, length, map, object_map } from "@pdfking/rfunc"
import { Identity, Keys, RecordMerge, Values } from "@pdfking/tfunc"
import MiniSearch from "minisearch"
import slugify from "../utils/slugify"

// abstract: consuming component must provide
//   data: query, all_options, default_results

const create_search_index = (options: any, documents: any) => {
  const index = new MiniSearch(
    RecordMerge({ storeFields: Keys(first(documents)) }, options) as any
  )
  index.addAll(documents)
  return index
}

const debounce_query = function (this: any, q: any) {
  if (this.searchTimeout) {
    clearTimeout(this.searchTimeout)
  }
  this.searchTimeout = setTimeout(() => {
    this.debouncedQuery = (q || "").trim()
    this.is_loading = false
  }, 250)
}

export const SearchMixin = CreateMixin({
  computed: {
    index() {
      if (length(this.all_options)) {
        return create_search_index(
          {
            fields: ["unicode", "slug", "search_keys"],
            idField: "id",
            searchOptions: {
              boost: { Keys: 4, slug: 7, unicode: 10 },
              fuzzy: 0.2,
              prefix: true,
            },
          },
          map(
            (i: any) => RecordMerge(i, { slug: slugify(i.unicode) }),
            Values(this.all_options)
          )
        )
      }
      return null
    },
    results() {
      if (this.debouncedQuery && this.index)
        return object_map(
          (v: any) => v.id,
          Identity,
          this.index.search(this.debouncedQuery)
        )
      return this.default_results || []
    },
  },
  data: {
    all_options: null as Record<string, any> | null,
    debouncedQuery: "",
    default_results: null as Record<string, any> | any[] | null,
    is_loading: true,
    query: "",
    searchTimeout: null as ReturnType<typeof setTimeout> | null,
  },
  init() {
    debounce_query.call(this, this.query)
  },
  methods: {
    filter_results: Identity,
  },
  watch: {
    query(q: any) {
      debounce_query.call(this, q)
    },
  },
})
